import { convertStyleData } from '@utils/tools';
import { customEvent } from '@utils/customEvent';
import { appMethod as app } from '@utils/app';
import './CustomTopNavCustomComponent.less';
export default function CustomTopNavCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                    // 组件数据
  const detailData = props.detailData;        // 详情页数据
  const dynamicData = props.dynamicData;      // 动态数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;

  const isTabBarPage = app.isTabBarPage()

  const currentPageRouter = app.getPageRouter()

  const homepageRouter = app.getHomepageRouter()

  const turnBack = () => {
    app.turnBack()
  }

  const turnHome = () => {
    app.turnToPage(homepageRouter, {}, true)
  }
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component custom-top-nav" ></div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/custom-top-nav-custom-component/CustomTopNavCustomComponent.jsx